export default {
    getAllClients: "https://r1wuzblvm3.execute-api.us-east-1.amazonaws.com/DEV/clientcrud?TableName=CLIENT"
}


// WEBPACK FOOTER //
// ./src/gateway/API.js